export default __webpack_public_path__ + "static/media/loading-opaque.b44e28fe.gif";